<template>
  <Modal title="提问详情" v-model="show" width="700px" @on-close="onCloseWin">
    <div class="user-questions-detail">
      <div class="questions-item" v-for="(g_item, g_index) in 1" :key="g_index">
        <div
          class="item"
          v-for="(item, index) in feedbackMessageDetail.processVOS"
          :key="index"
        >
          <div class="head">
            <div class="tip fjcsb">
              <span>{{ item.processTitle }}</span>
              <span>{{ item.processTime }}</span>
            </div>
            <div class="employeeinfo">{{ labelStr(item) }}</div>
          </div>
          <div class="body" v-if="item.processContent">
            <div class="questions">
              <span v-if="item.processContentType == 2">回复截图：</span>
              {{ item.processContent }}
            </div>
            <div v-if="item.carbonCopy" class="tip">
              抄送：{{ item.carbonCopy }}
            </div>
          </div>
        </div>
      </div>
      <empty
        v-if="
          !(
            feedbackMessageDetail.processVOS &&
            feedbackMessageDetail.processVOS.length
          )
        "
        text="暂无数据"
      />
    </div>
  </Modal>
</template>


<script>
export default {
  data() {
    return {
      info: {},
      show: false,
      reply: "",
      feedbackMessageDetail: {},
    };
  },
  methods: {
    onCloseWin() {
      this.$emit("close");
    },
    labelStr(item) {
      let str = item.employeeName;
      // 1 病程专家 4 医生 6负责人
      switch (item.label1) {
        case 1:
          str += " (病程专家)";
          break;
        case 4:
          str += " (医生)";
          break;
        case 6:
          str += " (负责人)";
          break;
      }

      // 	0 未回复 1 已回复
      switch (item.label2) {
        case 0:
          str += " (未回复)";
          break;
        case 1:
          str += " (已回复)";
          break;
      }
      return str;
    },
    getData() {
      this.api2("getFeedbackMessageDetail", {
        messageId: this.info.messageId,
      }).then((res) => {
        this.feedbackMessageDetail = res.result;
      });
    },
    open(res) {
      this.info = res;
      this.show = true;
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
.user-questions-detail {
  .questions-item {
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid #853a2f22;
    .item:last-child {
      .body {
        border-color: transparent;
      }
    }
    .head {
      padding: 10px 0;
    }
    .body {
      padding-left: 15px;
      margin-left: 15px;
      border-left: 2px solid #853a2f22;
      line-height: 2em;
      .questions {
        background-color: #ffffff66;
        padding: 5px 15px;
        border-radius: 5px;
      }
    }
  }
  .tip {
    font-size: 12px;
    opacity: 0.6;
  }
}
</style>